import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormControl, FormControlLabel, Radio, RadioGroup } from '@mui/material';

// Store
import { $adminSelected, setAdminSelected } from '../../../store/slices/sidebarMapFiltersSlice';
import { $mapLayersUpdating } from '../../../store/slices/mapSlice';

// Configs
import { SIDEBAR_MAP_ADMIN_FILTERS } from '../../../configs/map.configs';
import { RADIO_BUTTON_STYLE } from '../../../configs/muiStyling.config';
import { SidebarMapFiltersType } from '../../../configs/types';

function SidebarMapAdmins() {
  const dispatch = useDispatch();
  const adminSelected = useSelector($adminSelected);
  const mapLayersUpdating = useSelector($mapLayersUpdating);

  const handleSidebarMapAdminFilters = (event: any) => {
    const adminSelected = event.target.value;
    dispatch(setAdminSelected(adminSelected));
  };

  return (
    <div className='sidebar-map-admin'>
      <form>
        <FormControl>
          <RadioGroup
            row
            value={adminSelected}
            name='sidebar-map-admin-filters'
            onChange={handleSidebarMapAdminFilters}
          >
            {SIDEBAR_MAP_ADMIN_FILTERS.map((admin: SidebarMapFiltersType) => {
              const { label, value, tooltip } = admin;

              return (
                <FormControlLabel
                  key={`admin_${value}`}
                  value={value}
                  label={label}
                  title={tooltip}
                  control={<Radio sx={RADIO_BUTTON_STYLE} />}
                  disabled={mapLayersUpdating}
                />
              );
            })}
          </RadioGroup>
        </FormControl>
      </form>
    </div>
  );
}

export default SidebarMapAdmins;
